var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-select", {
                attrs: {
                  label: _vm.$ct("operator"),
                  items: _vm.operators,
                  value: _vm.operator,
                  fancy: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.setOperator($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("app-contact-search", {
                attrs: {
                  "group-id": 1,
                  "disable-create": "",
                  fancy: "",
                  label: _vm.$ct("search-client"),
                  value: _vm.searchValue,
                },
                on: {
                  input: function ($event) {
                    return _vm.onContactSelect($event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                { attrs: { "no-margin": "" } },
                _vm._l(_vm.clientCache, function (contact) {
                  return _c(
                    "w-chip",
                    {
                      key: contact.ID,
                      attrs: { closable: "" },
                      on: {
                        close: function ($event) {
                          return _vm.removeContact(contact)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(contact.getDisplayName()) +
                          " (" +
                          _vm._s(contact.ComputedFriendlyID) +
                          ") "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }